<template lang="pug">
v-dialog(v-model="dialog" fullscreen persistent transition="dialog-bottom-transition")
  v-card(v-if="dialog")
    v-toolbar(color="primary" dark flat)
      v-btn(icon @click="close")
        v-icon mdi-close
      v-toolbar-title.text-truncate Editar consumos (matriz){{ projectionName ? ' — ' + projectionName : '' }}
      v-spacer
      v-btn(text :loading="saving" :disabled="loading" @click="save")
        v-icon.mr-1 mdi-content-save
        span Guardar
    v-card-text.pa-4
      .text-body-2.mb-3
        | Filas = clientes · Columnas = productos o servicios. Escribe la cantidad ANUAL que cada cliente consume (o podría consumir). Deja la celda vacía si no aplica. El precio se toma del producto.
      div.text-center.py-8(v-if="loading")
        v-progress-circular(indeterminate color="primary")
      div.text-center.py-8(v-else-if="!customers.length || !products.length")
        v-icon(size="48" color="grey") mdi-table-off
        .mt-2.text-body-2 Necesitas al menos un cliente y un producto para usar la matriz.
      .matrix-wrap(v-else)
        table.matrix
          thead
            tr
              th.sticky-col.sticky-head Cliente
              th.sticky-head(v-for="p in products" :key="p.id" :title="p.sku") {{ p.name || p.sku }}
              th.sticky-head.text-right Total
          tbody
            tr(v-for="c in customers" :key="c.id")
              td.sticky-col(:title="c.name") {{ c.name }}
              td(v-for="p in products" :key="p.id")
                input.cell(type="number" min="0" step="1" v-model="grid[c.id][p.id]")
              td.text-right.rowtotal {{ rowTotal(c.id) | number }}
          tfoot
            tr
              td.sticky-col.sticky-foot Total
              td.sticky-foot.text-right(v-for="p in products" :key="p.id") {{ colTotal(p.id) | number }}
              td.sticky-foot.text-right {{ grandTotal | number }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      dialog: false,
      loading: false,
      saving: false,
      projectionId: null,
      projectionName: '',
      customers: [],
      products: [],
      grid: {},
    }
  },
  methods: {
    ...mapActions('commercial_projection', ['getProjectionMatrix', 'setProjectionMatrix']),
    async open (projectionId) {
      this.projectionId = projectionId
      this.dialog = true
      this.loading = true
      this.grid = {}
      const { data, error } = await this.getProjectionMatrix({ projection: projectionId })
      if (error || !data) {
        this.loading = false
        this.$toast ? this.$toast.error('No se pudo cargar la matriz') : alert('No se pudo cargar la matriz')
        return
      }
      this.projectionName = data.projection_name || ''
      this.customers = data.customers || []
      this.products = data.products || []
      const cells = data.cells || {}
      // Construyo toda la grilla de una vez (todas las claves definidas) para que
      // Vue 2 la haga reactiva sin necesidad de $set por celda.
      const grid = {}
      this.customers.forEach(c => {
        grid[c.id] = {}
        this.products.forEach(p => {
          const v = cells[c.id + '_' + p.id]
          grid[c.id][p.id] = (v === undefined || v === null) ? '' : v
        })
      })
      this.grid = grid
      this.loading = false
    },
    close () {
      this.dialog = false
    },
    rowTotal (customerId) {
      const row = this.grid[customerId] || {}
      return this.products.reduce((acc, p) => acc + (Number(row[p.id]) || 0), 0)
    },
    colTotal (productId) {
      return this.customers.reduce((acc, c) => acc + (Number((this.grid[c.id] || {})[productId]) || 0), 0)
    },
    async save () {
      this.saving = true
      const cells = []
      this.customers.forEach(c => {
        this.products.forEach(p => {
          const q = Math.round(Number(this.grid[c.id][p.id]) || 0)
          if (q > 0) cells.push({ customer: c.id, product: p.id, quantity: q })
        })
      })
      const { error } = await this.setProjectionMatrix({ data: { projection: this.projectionId, cells } })
      this.saving = false
      if (error) {
        this.$toast ? this.$toast.error('No se pudo guardar la matriz') : alert('No se pudo guardar la matriz')
        return
      }
      this.$toast && this.$toast.success('Consumos guardados')
      this.$emit('save')
      this.dialog = false
    },
  },
  computed: {
    grandTotal () {
      return this.customers.reduce((acc, c) => acc + this.rowTotal(c.id), 0)
    },
  },
}
</script>

<style scoped>
.matrix-wrap {
  overflow: auto;
  max-height: calc(100vh - 200px);
  border: 1px solid #E0E0E0;
  border-radius: 6px;
}
table.matrix {
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;
}
.matrix th,
.matrix td {
  border-right: 1px solid #ECECEC;
  border-bottom: 1px solid #ECECEC;
  padding: 2px 8px;
  white-space: nowrap;
}
.matrix .sticky-head {
  position: sticky;
  top: 0;
  background: #F5F6FA;
  z-index: 2;
  font-weight: 600;
  color: #2A2A4A;
}
.matrix .sticky-col {
  position: sticky;
  left: 0;
  background: #FFFFFF;
  z-index: 1;
  font-weight: 500;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.matrix th.sticky-col.sticky-head {
  z-index: 3;
}
.matrix .sticky-foot {
  position: sticky;
  bottom: 0;
  background: #F5F6FA;
  font-weight: 600;
}
.matrix .rowtotal {
  font-weight: 600;
  background: #FAFBFF;
}
.matrix input.cell {
  width: 92px;
  border: none;
  text-align: right;
  padding: 4px 2px;
  background: transparent;
}
.matrix input.cell:focus {
  outline: 2px solid #5575DF;
  border-radius: 3px;
}
</style>
